import { useSelector } from 'react-redux';
import restoreSvg from 'assets/icons/restore.svg';
import { RootState } from 'store';
import { restoreCreative } from 'modules/api/content';
import { useToggle } from 'customHooks/useToggle';
import { cancelFunctions } from 'utils/cancelFunctions';
import Modal from 'lib/Modal';
import Button, { Color, Size } from 'lib/Button';
import { DeleteRestoreCreativeProps } from './ButtonRenderer.types';

export const RestoreCreative: React.FC<DeleteRestoreCreativeProps> = ({ data, onComplete }) => {
  const restoreDialog = useToggle();
  const environmentId = useSelector((state: RootState) => state.environment.environmentId);

  const onRestore = async (): Promise<void> => {
    try {
      const marketId = data.market.find(({ environment }) => environment === environmentId)?.id;
      await restoreCreative(cancelFunctions, marketId);

      onComplete();
    } finally {
      restoreDialog.close();
    }
  };

  return (
    <>
      <Button
        onClick={restoreDialog.open}
        size={Size.LARGE}
        color={Color.GREEN}
        dataTestId={`restore-creative-button-${data.id}`}
        svg={restoreSvg}
      />

      <Modal
        dataTestId="restore-creative-modal"
        isOpen={restoreDialog.isOpen}
        icon={restoreSvg}
        title="Restore Creative?"
        actionButtons={
          <>
            <Button color={Color.PRIMARY} size={Size.LARGE} onClick={restoreDialog.close} label="Cancel" />
            <Button color={Color.DANGER} size={Size.LARGE} onClick={onRestore} label="Restore" />
          </>
        }
      >
        <p className="ml-8 body-base text-neutral-950-opacity-60">Are you sure you want to restore this creative?</p>
      </Modal>
    </>
  );
};
